module.exports = __webpack_public_path__ + "images/search-80ea18.svg";